const localStorageKey = {
  DEFAULT_LANG: "user_default_lang",
  TOKEN: "user_token",
  USER_INFO: "user_user_info",
};

export default localStorageKey;
